import { Button } from '@mui/material'
import { PanelLeftContract20Regular } from '@/components/Icon'
import SecondaryNavHeaderCollapsed from './SecondaryNavHeaderCollapsed'
import { useActiveWorkspaceName } from './useActiveWorkspaceName'
import nameStyles from './workspaceNameLabel.module.scss'
import styles from './SecondaryNavHeaderTitle.module.scss'

export default function SecondaryNavHeaderTitle({
  title,
  highlighted = true,
  collapsed = false,
  onToggleCollapse,
}) {
  const label = useActiveWorkspaceName(title)
  if (collapsed) return <SecondaryNavHeaderCollapsed onToggleCollapse={onToggleCollapse} />

  return (
    <div className={styles.headerRow} data-nav-chrome>
      <Button
        type="button"
        variant="text"
        aria-label={label}
        className={`${styles.headerButton} ${title === 'Chambers' ? styles.chambersWidth : styles.homeWidth} ${highlighted ? styles.highlighted : ''}`}
      >
        <span className={nameStyles.label}>
          {label}
        </span>
      </Button>
      <button
        type="button"
        className={styles.collapseButton}
        aria-label="Collapse panel"
        onClick={onToggleCollapse}
      >
        <PanelLeftContract20Regular aria-hidden />
      </button>
    </div>
  )
}

export { SecondaryNavHeaderTitle }
